import { useState } from "react";
import { AnimatedSeparator, Collapse } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function MotionPrimitivesDemo() {
  const [open, setOpen] = useState(true);
  const [runId, setRunId] = useState(0);
  return (
    <Section
      id="motion-primitives"
      title="AnimatedSeparator + Collapse"
      description="The PQA#2642 approve-card motion pair: a center-out separator reveal and the grid-rows drawer close. Transition-only (no keyframes to ship)."
    >
      <VariantBlock label="AnimatedSeparator" caption="remounts on Replay; collapsed reverses center-inward">
        <div className="w-full max-w-md space-y-3">
          <button
            type="button"
            className="rounded border border-border px-2 py-1 text-xs"
            onClick={() => setRunId(n => n + 1)}
          >
            Replay reveal
          </button>
          <AnimatedSeparator key={runId} />
          <AnimatedSeparator collapsed />
        </div>
      </VariantBlock>

      <VariantBlock label="Collapse" caption="two-beat close: separator leads, drawer follows (delayMs=100)">
        <div className="w-full max-w-md space-y-2">
          <button
            type="button"
            className="rounded border border-border px-2 py-1 text-xs"
            onClick={() => setOpen(o => !o)}
          >
            {open ? "Close drawer" : "Open drawer"}
          </button>
          <div className="rounded-xl border border-border/70 p-3">
            <p className="text-sm">Always-visible card content.</p>
            <Collapse open={open} delayMs={100}>
              <div className="pt-2">
                <AnimatedSeparator collapsed={!open} />
                <p className="pt-2 text-sm text-muted-foreground">
                  Drawer content: stays mounted while closed, leaves the tab order via inert.
                </p>
                <button type="button" className="mt-1 rounded border border-border px-2 py-1 text-xs">
                  Focusable child
                </button>
              </div>
            </Collapse>
          </div>
        </div>
      </VariantBlock>
    </Section>
  );
}
